import axios from "axios";
import Vue from 'vue'

const $api_key = Vue.prototype.$api_key;
const $base_url = Vue.prototype.$base_url;

export const AdminService = {
    getSucursales(token = null){
        const headers = {
            "Content-Type": "application/json",
            "x-api-key": $api_key,
            token: token,
        };
        let config = {
        headers: headers,
        };
        return axios.get($base_url + "admin/sucursales", config, {
            headers: headers,
        })
    },
    getTiposDescuentos(token = null){
        const headers = {
            "Content-Type": "application/json",
            "x-api-key": $api_key,
            token: token,
        };
        let config = {
            headers: headers,
        };
        return axios.get($base_url + "admin/tipos_descuentos", config, {
            headers: headers,
        })
    },
    getTiposAlianzas(token = null){
        const headers = {
            "Content-Type": "application/json",
            "x-api-key": $api_key,
            token: token,
        };
        let config = {
            headers: headers,
        };
        return axios.get($base_url + "admin/tipos_alianzas", config, {
            headers: headers,
        })
    },
    getCategorias(token = null){
        const headers = {
            "Content-Type": "application/json",
            "x-api-key": $api_key,
            token: token,
        };
        let config = {
            headers: headers,
        };
        return axios.get($base_url + "admin/categorias", config, {
            headers: headers,
        })
    },
    getUsuarios(token= null, params = null){
        const headers = {
            "Content-Type": "application/json",
            "x-api-key": $api_key,
            token: token,
        };
        let config = {
            headers,
            params
        };
        return axios.get($base_url + "admin/usuarios", config, {
            headers: headers,
        })
    },
    setAdmin(token= null, params = null){
        const headers = {
            "Content-Type": "application/json",
            "x-api-key": $api_key,
            token: token,
        };
        return axios.post($base_url + "admin/set_admin", params, {
            headers: headers,
        })
    },
    UpdateAdmin(token= null, params = null){
        const headers = {
            "Content-Type": "application/json",
            "x-api-key": $api_key,
            token: token,
        };
        return axios.post($base_url + "admin/update_admin", params, {
            headers: headers,
        })
    }
};
export default { AdminService };